var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.thumbnail)?_c('a-avatar',{attrs:{"size":_vm.size ? _vm.size : 'default',"src":_vm.thumbnail.url}}):_c('a-avatar',{attrs:{"size":_vm.size ? _vm.size : 'default',"icon":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }